import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Link, useParams } from "react-router-dom";

import { messages } from "./messages";
import { HistoryInfiniteScroll } from "components/HistoryInfiniteScroll";
import { Button } from "@letsbit/milkylb";
import { FormatedValue } from "components/FormatedValue";
import { BackButton } from "components/BackButton";
import { ReactComponent as RecieveIcon } from "assets/images/icons/receive.svg";
import { useMemberPlatformBalancePage } from "../MemberPlatformBalancePage/useMemberPlatformBalancePage";
import LoadingAnimation from "components/LoadingAnimation";

export const MemberPlatformBalanceCurrencyPage: React.FC = () => {
  const { currency, uid } = useParams<{
    currency: string;
    uid: string;
  }>();
  const intl = useIntl();
  const { wallets, name, isLoading } = useMemberPlatformBalancePage(uid);

  const wallet = currency && wallets ? wallets?.[currency] : undefined;
  const depositCurrencyNetwork = wallet?.currency_networks.find(
    (network) => network.deposit_enabled,
  );

  return isLoading || !uid ? (
    <LoadingAnimation />
  ) : (
    <div className="flex h-full w-full flex-col">
      <div className="mb-8 flex items-center justify-between border-b border-[--milkylb-color-secondary-200] pb-8">
        <div className="flex flex-col items-start">
          <BackButton className="mb-4" />
          <h1 className="font-['Tomato_Grotesk'] text-4xl font-bold">
            <FormattedMessage
              {...messages.title}
              values={{
                currency: wallet?.ticker_id.toUpperCase(),
                name: name || "",
              }}
            />
          </h1>
        </div>
      </div>
      {wallet && (
        <HistoryInfiniteScroll
          filter={
            currency
              ? {
                  currencies: new Set([currency]),
                }
              : undefined
          }
          headerSticky={intl.formatMessage(messages.lastMovements)}
          header={
            <div className="mb-8">
              <h3 className="font-['Tomato_Grotesk'] text-2xl font-bold text-[--milkylb-color-neutral-600]">
                <FormattedMessage {...messages.totalLabel} />
              </h3>
              <h2 className="font-['Tomato_Grotesk'] text-4xl font-bold text-[--milkylb-color-neutral-800]">
                {wallet && (
                  <FormatedValue
                    value={wallet?.total_balance}
                    precision={wallet?.precision}
                  />
                )}{" "}
                {wallet?.ticker_id.toUpperCase()}
              </h2>
              <div className="mt-6 flex">
                {depositCurrencyNetwork && (
                  <Link
                    to={`/logged/members/${uid}/platform/deposit-address/${currency}/${depositCurrencyNetwork.payment_network.id}`}
                  >
                    <Button
                      className="letsbit-ui-button-outline-svg-filled"
                      leftIcon={RecieveIcon}
                      fill="outline"
                    >
                      <FormattedMessage {...messages.receiveButton} />
                    </Button>
                  </Link>
                )}
              </div>
            </div>
          }
          chipsAlign="right"
          memberUid={uid}
        />
      )}
    </div>
  );
};
